export const PROJECT_TIMELINE_CONFIG = {
    name            : 'Timeline',
    menuName        : 'Timeline',
    icon            : 'i5-timeline-2',
    image           : 'timeline',
    iconSvg         : 'isvg-view-timeline',
    url             : 'timeline',
    stringId        : 'timeline',
    description     : 'Display the items and events you need on the timeline.',
    inheritance     : true,
    canBeInProject  : true,
}
